import { render, staticRenderFns } from "./InsuranceRefundTableList.vue?vue&type=template&id=d12b6c64&scoped=true&"
import script from "./InsuranceRefundTableList.vue?vue&type=script&lang=js&"
export * from "./InsuranceRefundTableList.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceRefundTableList.vue?vue&type=style&index=0&id=d12b6c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d12b6c64",
  null
  
)

export default component.exports